import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';


import ListItem from "../common/listItem";
import FilterBar from "../common/FilterBar";
import * as vignetsActions from "../../actions/vignets";
import NewPlaylist from "./NewPlaylist";

import Loader from 'react-loader-spinner';
import AuthService from "../../lib/AuthService";
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class PlaylistContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            modal: false,
            wrapClass : 'Playlist-container ',
            items : undefined,
            image_path: null,
            playlistName: "",
            playlistDesc:""
        };
        this.Auth = new AuthService();
        this.onDragEnd = this.onDragEnd.bind(this);
        this.showVignetsList = this.showVignetsList.bind(this);
        this.forceUpdatePlaylist = this.forceUpdatePlaylist.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.showEditModal = this.showEditModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.listenToScroll=this.listenToScroll.bind(this);
    }

    getUploadedFile(fileName) {
        this.setState({
            image_path: fileName
        });
    }
    componentDidMount() {

        let data = { userid : this.Auth.getProfile().user_id,size:50,offset:0};
        this.props.allPlaylistData(data);
        //this.props.allVignetsData(data);

        console.log("showplaylist"+ this.props.showPlaylist); console.log("showVignets"+ this.props.showVignets);
        this.setState(
            {
                showPlaylist: this.props.showPlaylist,
                showVignets: this.props.showVignets,
                plnameClass: 'playlist-side-header inactive',
                showPlNameSave : false,
                nameUpdated : false

            }
        );

        const container = document.querySelector('.right-bottom-area');
        container.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        const container = document.querySelector('.right-bottom-area');
        container.removeEventListener('scroll', this.listenToScroll)
    }

    listenToScroll = () => {
        const container = document.querySelector('.right-bottom-area')
        let lastOffset = document.querySelector('.list-container').childElementCount-1;
        var scrollTop = container.scrollTop;
        var scrollHeight = container.scrollHeight;
        var offsetHeight = container.offsetHeight;
        var contentHeight = scrollHeight - offsetHeight;

        // console.log(scrollTop+"----"+scrollHeight+"----"+offsetHeight+"-----"+contentHeight);

        if (contentHeight <= scrollTop) {
            let plId = "";
            let data = { userid : this.Auth.getProfile().user_id,size:50,offset:lastOffset};
            this.props.morePlaylistData(data);
        }

    }
    shouldComponentUpdate(nextProps, nextState){

        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        // Typical usage (don't forget to compare props):

        if (this.props.playlistData.playListItems !== prevProps.playlistData.playListItems) {
            this.setState(
                {
                    showPlaylist: this.props.showPlaylist,
                    showVignets: this.props.showVignets,
                    showEdit: this.props.showEdit

                }
            );
        }

        console.log(this.state.nameUpdated+"===="+prevState.nameUpdated+"===="+this.state.showPlaylist+"===="+prevState.showPlaylist);

        if(this.props.playlistData.playlistCreated !== prevProps.playlistData.playlistCreated ||  ( this.state.nameUpdated === true && this.state.showPlaylist !== prevState.showPlaylist)) {
            this.forceUpdatePlaylist();
        }

        if(this.props.playlistData.playlistUpdated !== prevProps.playlistData.playlistUpdated ) {
            this.showEditPlaylist(this.props.playlistData.playlistId);
        }


    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        //Name validation

        if( this.state.playlistName === '') {
            formInvalid++;
            document.getElementsByName('playlistName')[0].classList.add('is-invalid');
        };

        //* Desc validation
        if( this.state.playlistDesc === '') {
            formInvalid++;
            document.getElementsByName('playlistDesc')[0].classList.add('is-invalid');
        };



        if( formInvalid === 0) {

            var playlistData = { plName: this.state.playlistName, plDesc : this.state.playlistDesc, user_id : this.Auth.getProfile().user_id , vigIds:'', plImage : this.state.image_path, plId :''};
            console.log(playlistData);
            let playlistCreated = this.props.createPlaylist(playlistData);
            console.log(playlistCreated);
            this.mToggle();


        }

    }
    forceUpdatePlaylist(){
        console.log("force");
        let data = {userid : this.Auth.getProfile().user_id,size:50,offset:0};
        this.props.allPlaylistData(data);
    }

    showVignetsList() {

        this.props.newPlaylist();
        this.setState(
            {
                showPlaylist: false,
                showVignets: true,
                showEdit: false,
                wrapClass:'',
                nameUpdated : false

            }
        );
    }

    hideVignetsList() {
        this.props.hideCreatePlaylist();
        this.setState(
            {
                showPlaylist: true,
                showVignets: false,
                showEdit: false
            }
        );


    }

    showEditPlaylist(plId) {

        console.log("showEdit");
        let data = {"plId" : plId};
        this.props.getPlaylist(data);

        this.setState(
            {
                showPlaylist: false,
                showVignets: true,
                showEdit:true,
                wrapClass:'split-panel',
                nameUpdated : false
            }
        );

        //this.setState({playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].name:''});

    }

    removeFromPlaylist(vignetId) {
        let data = {plid : this.props.playlistData.playlistId, vigid :vignetId}
        this.props.removeFromPlaylist(data);
    }

    editPlName() {
        this.setState(
            {
                plnameClass: 'playlist-side-header ',
                showPlNameSave : true
            }
        );
    }

    savePlName() {
        let data = {plname : this.state.playlist_name, plid :this.props.playlistData.playlistId, userid : this.Auth.getProfile().user_id}
        this.props.savePlaylistName(data);
        this.setState(
            {
                plnameClass: 'playlist-side-header inactive',
                showPlNameSave : false,
                nameUpdated : true

            }
        );

    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.props.playlistData.playListDetail,
            result.source.index,
            result.destination.index
        );

        console.log(result.source.index);
        console.log(result.destination.index);

        this.props.sortPlaylist({plItems: items, plId : this.props.playlistData.playlistId});


        this.setState({
            items,
        });
    }

    showDetailPopup(playlist) {

        console.log("showEdit");

        console.log(playlist);

        this.setState(
            {
                showPop: true,
                playlist : playlist
            },
            () => {
                console.log(this.state.showDetailPop);
                console.log(this.state.vignet);
            });

        //this.setState({playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].name:''});

    }

    showEditModal() {
        this.props.newPlaylist();
       this.props.showPlaylistModal();
    }



    render() {

        let playListData = (this.props.playlistData.searchText || this.props.playlistData.sort) ? this.props.playlistData.filteredData :  this.props.playlistData.playListItems;

        return (

            <div className={this.state.wrapClass}>

                {this.state.showPlaylist &&
                <div className="list-container">

                    {!playListData &&
                    <div className="loaderWrapper">
                        <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                    </div>
                    }

                    <div className="panel-block new-panel" onClick={this.showEditModal}>

                        <div className="gallery-thumb">
                            <div className="new-button-block">
                                <button className="icon-lib add-button float-add"></button>
                                <p>Add Playlist</p>
                            </div>
                        </div>

                    </div>

                    {playListData && playListData.length > 0 &&

                    playListData.map((entry, index) => <ListItem detail={entry} id={index} showEditPlaylist={this.showEditPlaylist.bind(this)} showDetailPopup={this.showDetailPopup.bind(this)} itemType="playlist"/>
                    )
                    }
                    {playListData && playListData.length === 0 &&

                    <div>No Playlist Added</div>
                    }
                </div>
                }

                <NewPlaylist />
            </div>


        );
    }
}

PlaylistContainer.propTypes = {
    showPlaylist: PropTypes.bool,
    showVignets : PropTypes.bool
}

function mapStateToProps(state) {
    return {
        playlistData  :state.playlist.playlistData,
        pageInfo  : state.pages.pageSettings,
        vignetsData  :state.vignets.vignetsData
    };

}
export default  withRouter(connect(mapStateToProps, {
    allPlaylistData : playlistActions.getPlayLists,
    allFilteredData : playlistActions.searchPlaylists,
    allVignetsData : vignetsActions.fetchVignetsData,
    getPlaylist : playlistActions.getPlayListDetails,
    removeFromPlaylist : playlistActions.removeFromPlaylist,
    savePlaylistName :  playlistActions.savePlaylistName,
    newPlaylist:playlistActions.newPlaylist,
    hideCreatePlaylist:playlistActions.hideCreatePlaylist,
    sortPlaylist: playlistActions.sortPlaylist,
    createPlaylist : playlistActions.createPlaylist,
    showPlaylistModal : playlistActions.showPlaylistModal,
    morePlaylistData: playlistActions.getmorePlayLists
})(PlaylistContainer, FilterBar));




// WEBPACK FOOTER //
// ./src/components/playlist/PlaylistContainer.js